// GLP-1 cannot be sold in Louisiana or Mississippi (state law). Every state list
// leaves them out; every state a shopper can type or autofill (the checkout State
// box, a Google address pick, an Apple Pay / Google Pay billing address) goes
// through isBlockedState before a charge. The copy is fixed by the NewSelf
// monorepo rules: "Service is not available in this state".

export const BLOCKED_STATE_MESSAGE = 'Service is not available in this state';

const BLOCKED = ['LA', 'MS', 'LOUISIANA', 'MISSISSIPPI'];

export function isBlockedState(state) {
  return BLOCKED.includes(String(state || '').trim().toUpperCase());
}
